<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p><a id="toc">
<div class="fmh1">Table of Contents</div>
</a><div class="cfmh"><a id="toc"></a><a href="#/tomh_9780748113736_oeb_tp_r1">Title Page</a></div>
<div class="cbmh"><a href="#/tomh_9780748113736_oeb_cop_r1">Copyright Page</a></div>
<div class="cbmh"><a href="#/tomh_9780748113736_oeb_fm1_r1">Also by Tom Holt</a></div>
<div class="cfmh"><a href="#/tomh_9780748113736_oeb_ded_r1">Dedication</a></div>
<div> <br/></div>
<div class="cct"><a href="#/tomh_9780748113736_oeb_c01_r1">CHAPTER ONE</a></div>
<div class="cct"><a href="#/tomh_9780748113736_oeb_c02_r1">CHAPTER TWO</a></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c03_r1" title="Link target outside of Sample">CHAPTER THREE</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c04_r1" title="Link target outside of Sample">CHAPTER FOUR</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c05_r1" title="Link target outside of Sample">CHAPTER FIVE</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c06_r1" title="Link target outside of Sample">CHAPTER  SIX</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c07_r1" title="Link target outside of Sample">CHAPTER SEVEN</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c08_r1" title="Link target outside of Sample">CHAPTER EIGHT</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c09_r1" title="Link target outside of Sample">CHAPTER NINE</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c10_r1" title="Link target outside of Sample">CHAPTER  TEN</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c11_r1" title="Link target outside of Sample">CHAPTER ELEVEN</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c12_r1" title="Link target outside of Sample">CHAPTER TWELVE</span></div>
<div class="cct"><span href="#/tomh_9780748113736_oeb_c13_r1" title="Link target outside of Sample">CHAPTER THIRTEEN</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113736_oeb_toc_r1.vue?87765ade